export default "__VITE_ASSET__2hjKiEmA__"